import { render, staticRenderFns } from "./forex-expert.vue?vue&type=template&id=f140b5f2&scoped=true"
import script from "./forex-expert.vue?vue&type=script&lang=js"
export * from "./forex-expert.vue?vue&type=script&lang=js"
import style0 from "./forex-expert.vue?vue&type=style&index=0&id=f140b5f2&prod&lang=css"
import style1 from "./forex-expert.vue?vue&type=style&index=1&id=f140b5f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f140b5f2",
  null
  
)

export default component.exports